import React, { useState, useEffect } from 'react';
import { useSprings } from 'react-spring';
import { useGesture } from 'react-with-gesture';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Card from './Card';
import * as actions from '../../../redux/actions/recycleRight';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 35px;
`;

/**
 * This component includes all the cards in each level of the game
 * This component includes all the core functions for the animation of swiping the cards
 *
 */

const Deck = ({
  currentLevelKey,
  disabled,
  onSwipeRight,
  onSwipeLeft,
  questionIndex,
  feedback,
  recycleRightData
}) => {
  const [xValue, setXValue] = useState(null);
  const [tensionValue, setTensionValue] = useState(null);

  const objsValue = recycleRightData[currentLevelKey];

  let objs = [...objsValue].reverse();
  objs = objs.slice(0, objs.length - questionIndex);
  const cards = Array.from(Array(objs.length).keys());

  const to = (i) => ({
    x: 0,
    // y: i * -10,
    y: i,
    scale: 1,
    // rot: -10 + Math.random() * 20,
    rot: 0,
    delay: i * 100
  });
  // eslint-disable-next-line no-unused-vars, arrow-parens
  const from = i => ({ rot: 0, scale: 1.5, y: -1000 });

  const trans = (r) => `rotateX(0deg) rotateY(${r
    / 10}deg) rotateZ(${r}deg) scale(${1})`;

  const [gone] = useState(() => new Set());

  const [props, set] = (questionIndex === 0 && !feedback) ? useSprings(cards.length, (i) => ({
    ...to(i),
    from: from(i)
  })) : useSprings(cards.length, (i) => ({
    ...to(i)
  }));

  const bind = useGesture(
    ({
      args: [index],
      down,
      delta: [xDelta],
      direction: [xDir],
      velocity
    }) => {
      const trigger = velocity > 0.2;

      const dir = xDir < 0 ? -1 : 1;

      if (!down && trigger) gone.add(index);

      set((i) => {
        if (index !== i) return;
        const isGone = gone.has(index);

        // eslint-disable-next-line no-nested-ternary
        const x = isGone ? (200 + window.innerWidth) * dir : down ? xDelta : 0;

        const rot = xDelta / 100 + (isGone ? dir * 10 * velocity : 0);

        const scale = down ? 1.1 : 1;

        // Swipre right: tension: 200 and x: 560
        // Swipre left: tension: 200 and x: -560

        setXValue(x);
        // eslint-disable-next-line no-nested-ternary
        setTensionValue(down ? 800 : isGone ? 200 : 500);
        // eslint-disable-next-line consistent-return
        return {
          x,
          rot,
          scale,
          delay: undefined,
          // eslint-disable-next-line no-nested-ternary
          config: { friction: 50, tension: down ? 800 : isGone ? 200 : 500 }
        };
      });
    }
  );

  useEffect(() => {
    if (disabled) return;
    if (tensionValue === 200 && xValue >= window.innerWidth + 200) {
      localStorage.setItem('isSwiped', 'true');
      onSwipeRight();
    }
    if (tensionValue === 200 && xValue <= -1 * window.innerWidth - 200) {
      localStorage.setItem('isSwiped', 'true');
      onSwipeLeft();
    }
  }, [disabled, tensionValue, xValue]);

  return props.map(({
    x, y, rot, scale
  }, i) => (
    <Container>
      {
        (x && y && (
          <Card
            i={i}
            x={x}
            y={y}
            rot={rot}
            scale={scale}
            trans={trans}
            cards={cards}
            objs={objs}
            bind={bind}
            onSwipeRight={onSwipeRight}
            onSwipeLeft={onSwipeLeft}
            feedback={feedback}
          />
        )
        )
      }
    </Container>
  ));
};

export default connect(
  (store) => ({
    currentLevel: store.recycleRight.currentLevel,
    doneMaterials: store.recycleRight.doneMaterials,
    recycleRightData: store.recycleRight.allRrData
  }),
  (dispatch) => ({
    setDoneMaterial: (material) => dispatch(actions.setDoneMaterial(material)),
    setSwiperCurrentLevel: (level) => dispatch(actions.setSwiperCurrentLevel(level))
  })
)(Deck);
